import { render, staticRenderFns } from "./AppButtonSubmit.vue?vue&type=template&id=266bcbb6&scoped=true&"
import script from "./AppButtonSubmit.vue?vue&type=script&lang=js&"
export * from "./AppButtonSubmit.vue?vue&type=script&lang=js&"
import style0 from "./AppButtonSubmit.vue?vue&type=style&index=0&id=266bcbb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266bcbb6",
  null
  
)

export default component.exports